export type ReadonlyDataSeedingEndpoints = {
    readonly GetSeedMethods: string;
    readonly ExecuteSeedMethod: string;
}

const controller = 'api/DataSeeding';

const DataSeedingEndpoints: ReadonlyDataSeedingEndpoints = {
    GetSeedMethods: `${controller}/GetSeedMethods`,
    ExecuteSeedMethod: `${controller}/ExecuteSeedMethod`,
};

export { DataSeedingEndpoints };